import { render, staticRenderFns } from "./right-center.vue?vue&type=template&id=f213de1a&scoped=true"
import script from "./right-center.vue?vue&type=script&lang=js"
export * from "./right-center.vue?vue&type=script&lang=js"
import style0 from "./right-center.vue?vue&type=style&index=0&id=f213de1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f213de1a",
  null
  
)

export default component.exports